/* eslint-disable camelcase */
/* eslint-disable no-restricted-globals */
import "./AddComment.scss";
import React, { useState } from "react";
import FileIcon from "@atlaskit/icon/glyph/file";

type Props = {
    onSubmitComment: (file: File | null, text: string) => Promise<boolean>;
};

export const AddComment = (props: Props) => {
    const [file, setFile] = useState<File | null>(null);
    const [text, setText] = useState<string>("");

    return (
        <div className="add-comment">
            <div className="messagecontainer">
                <div className="file">
                    <label htmlFor="file" className="label">
                        {!file ? "+" : <FileIcon label="file" />}
                    </label>
                    <input
                        type="file"
                        id="file"
                        onChange={(event) => {
                            event.stopPropagation();
                            event.preventDefault();
                            if (event.target.files && event.target.files[0]) {
                                setFile(event.target.files[0]);
                            }
                        }}
                    />
                </div>
                <div className="input">
                    <textarea
                        onChange={(ev) => {
                            if (
                                ev.target.value !== null ||
                                ev.target.value !== null
                            ) {
                                setText(ev.target.value);
                            }
                        }}
                        value={text}
                        className="text"
                    ></textarea>
                </div>
                <div className="send">
                    <input
                        onClick={() => {
                            if (file === null && text === "") {
                                return;
                            }
                            props.onSubmitComment(file, text).then((res) => {
                                setFile(null);
                                setText("");
                            });
                        }}
                        type="submit"
                        className="btn"
                        value={"Absenden"}
                    />
                </div>
            </div>
        </div>
    );
};
